import Grid from "@mui/material/Grid2";

import { TabSessionStorageResponse } from "../../../../models/api/TabSessionStorage";
import { flexRow } from "../../../../styles/mui/styles/display";
import { FieldSpacing } from "../../styles/style";
import ReadOnlyField from "../../../../components/FormPriorAuthReAuth/ReadOnlyField";
import { getValue } from "../../../../utils";
import { Discipline, ListOptions } from "../../../../models/Master";
import { formatDate } from "../../../../utils/DateTime";
import { DateFormats } from "../../../../constants/Date";

export interface PropsFromState {
  tabSessionStorage: TabSessionStorageResponse;
  masterCareTypeState: ListOptions[];
  disciplineListState: Discipline[];
}

type AllProps = PropsFromState;

const RequestServices: React.FC<AllProps> = ({
  tabSessionStorage,
  masterCareTypeState,
  disciplineListState,
}) => {
  const getDiscipline = () => {
    const disciplineIds =
      getValue(tabSessionStorage, "response.requestService.discipline") || [];
    return disciplineIds
      .map((id: number) => {
        const item = disciplineListState.find(
          (list) => list.disciplineId === id
        );
        return item?.disciplineName ?? id;
      })
      .join(", ");
  };

  const getCareTypes = () => {
    const careTypes =
      getValue(
        tabSessionStorage,
        "response.requestService.referralCareTypeDto"
      ) || [];
    return careTypes
      .map((item: any) => {
        const option = masterCareTypeState.find(
          (list) => list.value === item.careTypeId
        );
        return option?.label ?? item.careTypeId;
      })
      .join(", ");
  };

  return (
    <Grid container sx={flexRow}>
      {[
        {
          label: "Start of Care:",
          value: formatDate(
            getValue(tabSessionStorage, "response.requestService.startOfCare"),
            DateFormats.MM_DD_YYYY,
            DateFormats.YYYY_MM_DD,
            true
          ),
        },
        {
          label: "Care Type:",
          value: getCareTypes(),
        },
        {
          label: "Disciplines:",
          value: getDiscipline(),
        },
      ].map(({ label, value }) => (
        <Grid key={label} size={{ xs: 4 }} sx={FieldSpacing}>
          <ReadOnlyField label={label} value={value} />
        </Grid>
      ))}
    </Grid>
  );
};

export default RequestServices;
